import { PaymentMethodModelType } from '@teinor/erp/types/company/config/paymentMethod'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

export interface PaymentMethodsAction {
    type: 'CHANGE_PAYMENTMETHODS'
    payload: PaymentMethodModelType[]
}

export type PaymentMethodsPayload = PaymentMethodJson
export type PaymentMethodJson = { all: { [id: number]: PaymentMethodModelType }, active: { [id: number]: PaymentMethodModelType } } | null

export default function paymentMethods(state: PaymentMethodJson = null, action: PaymentMethodsAction): PaymentMethodJson {
    switch (action.type) {
        case 'CHANGE_PAYMENTMETHODS':
            const all = dictionaryComplexFromJsonArr(action.payload)
            const active: { [id: number]: PaymentMethodModelType } ={}
            for (const element of action.payload) {
                if(element.active){
                    active[element.id] = element
                }
            }
            return state = { all, active }
        default:
            return state
    }
}